const fieldsPersentage = ['average_utilization', 'average_availability', 'on_time_delivery']
export function formatValues(key, value) {
  if (fieldsPersentage.includes(key)) {
    return `${value}%` || '-'
  }
  return value || '-'
}
